module.exports = __webpack_public_path__ + "img/vignettes-asso_0005_institut-du-monde-arabe.ce25faf4.jpg";